import styled, { css } from 'styled-components';
import { color } from './helpers/variables';
import { dynamicFontSize } from './helpers/mixins';

export const ProductTag = styled.div`
  ${props => dynamicFontSize(props.minFontSize ? props.minFontSize : 8, props.maxFontSize ? props.maxFontSize : 12)};
  top: ${props => (props.spacing ? props.spacing : '8px')};
  left: ${props => (props.spacing ? props.spacing : '8px')};
  color: #fff;
  background-color: ${props => (props.color ? props.color : '#333')};
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  padding: 2px 5px;
  margin: 0 5px 5px 0;
  position: ${props => (props.absolute ? 'absolute' : 'initial')};

  @media (min-width: 640px) {
    padding: 3px 12px;
  }

  ${props =>
    props.sale &&
    css`
      background-color: ${color.sale};
    `} ${props =>
    props.big &&
    css`
      padding: 3px 8px;
    `};
`;



// WEBPACK FOOTER //
// ./src/styles/ProductTag.js